import React, { useState, useEffect } from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useActiveListContext,
} from '../../../context';
import { COLORS } from '../../../constants';
import { Float } from '../../float';
import { timestamp } from '../../../lib';
import { ButtonContainer } from '../../layouts/styles';
import { resizeOnInput } from '../../../helpers';
import { Core } from '../..';
import { ColorChoice } from './color-choice';
import { Desktop } from '../../../media_queries';
import { ColorContainer } from './styles';

export const AddList = ({ hasScroll, addListRef = null }) => {
  const { firebase } = useFirebaseContext();
  const [show, setShow] = useState(false);
  const { lists, setLists, setMaxModifiedAt } = useAllInOneContext();
  const [invalid, setInvalid] = useState(false);
  const [isInAdd, setIsInAdd] = useState(false);
  const { themeColor, themeColor_L2, themeColor_D2 } = useActiveListContext();
  const [listName, setListName] = useState('');
  const [listColor, setListColor] = useState(0);
  const [progress, setProgress] = useState(0);
  const [forceCloseNotYet, setForceCloseNotYet] = useState(true);

  const resetAll = () => {
    setListName('');
    setListColor(0);
    setForceCloseNotYet(true);
  };

  useEffect(() => {
    if (addListRef && addListRef.current)
      addListRef.current.onclick = () => setShow(true);
  }, []);

  useEffect(() => {
    if (!forceCloseNotYet) {
      setShow(false);
      resetAll();
    }
  }, [forceCloseNotYet]);

  useEffect(() => {
    if (listName != '') setInvalid(false);
    else setInvalid(true);
  }, [listName]);

  const addList = () => {
    if (listName) {
      const userDB = firebase
        .firestore()
        .collection('users')
        .doc(firebase.auth().currentUser.uid);

      const tempModifiedAt = timestamp.now().toMillis();
      setProgress(20);

      const temp = {
        order: lists.length,
        name: listName,
        color: listColor,
        taskCount: 0,
        modifiedAt: tempModifiedAt,
      };
      setProgress(40);

      userDB
        .collection('lists')
        .add(temp)
        .then((doc) => {
          temp.docID = doc.id;
          setProgress(60);

          const newArray = lists;
          newArray.push(temp);
          setProgress(80);

          setLists();
          setLists(newArray);
          setProgress(100);

          setMaxModifiedAt(tempModifiedAt);
          setIsInAdd(false);
          setShow(false);
          resetAll();

          // setSelectedProject("INBOX");
        });
    }
  };

  return (
    <>
      <Core.ForceAlert
        color={themeColor}
        progress={progress}
        setProgress={setProgress}
        showBox={isInAdd}
      >
        Adding the list...
      </Core.ForceAlert>

      <Desktop>
        <ButtonContainer position='left'>
          <Float.BotButton
            color={themeColor}
            colorD2={themeColor_D2}
            hasScroll={hasScroll}
            onClick={() => setShow(true)}
          >
            <span className='button-icon'></span>
            <span className='button-label'>Add List</span>
          </Float.BotButton>
        </ButtonContainer>
      </Desktop>

      <Float.Card
        disabled={invalid}
        color={themeColor}
        color_L2={themeColor_L2}
        showBox={show}
        setShowBox={setForceCloseNotYet}
      >
        <Float.CardChild >
          <div className='title'>New List</div>
          <div className='block' style={{ padding: '4px' }}>
            <Core.TextArea
              value={listName}
              onChange={(e) => {
                resizeOnInput(e.target);
                setListName(e.target.value);
              }}
              type='text'
              placeholder='List Name'
              autoFocus
              rows='1'
            ></Core.TextArea>
          </div>
          <ColorContainer
            className='block'
            style={{
              display: 'grid',
              placeItems: 'center',
              gridTemplateColumns: 'repeat(auto-fit, minmax(25px, 1fr))',
              gridGap: '10px',
              padding: '20px',
            }}
          >
            {COLORS.map((color, index) => (
              <ColorChoice
                key={index}
                color={color}
                index={index}
                listColor={listColor}
                setListColor={setListColor}
              />
            ))}
          </ColorContainer>
        </Float.CardChild>
        <div>
          <div
            type='button'
            onClick={() => {
              setIsInAdd(true);
              addList();
            }}
          >
            Add
          </div>

          <div
            onClick={() => {
              setShow(false);
              resetAll();
            }}
          >
            Cancel
          </div>
        </div>
      </Float.Card>
    </>
  );
};
